import { getBackendUrl } from '../utils/utils';

export type PlanType = 'monthly' | 'yearly';

export interface CheckoutSessionResponse {
  checkout_url: string;
  session_id: string;
}

export async function createCheckoutSession(
  token: string,
  planType: PlanType,
  seatCount: number = 1,
  isAddSeats: boolean = false,
): Promise<CheckoutSessionResponse> {
  const response = await fetch(`${getBackendUrl()}/payment/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ plan_type: planType, seat_count: seatCount, is_add_seats: isAddSeats }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    // A 422 carries a list of validation errors, not a string — don't surface "[object Object]".
    const detail = typeof error.detail === 'string' ? error.detail : null;
    throw new Error(detail ?? 'Failed to initiate payment. Please try again.');
  }

  return response.json();
}

// /payment/seats-info lives in profileService — it is the buyer's Stripe seat
// purchase, which only the profile/subscription views should render.
